import React from "react";
import styled from "styled-components";
import Header from './Header'
import {Outlet} from "react-router-dom";


function Layout(){
  
  return(
       <>
        <Wrapper>
           <Header />
           <Outlet />
           {/* <Home /> */}

        </Wrapper>
       </>
  );
}

const Wrapper = styled.div`
  margin : 0px;
  padding : 0px;
  object-fit : cover;
`

 export default Layout;